import React from 'react';
import Modal from '../../../../../../component/modal/Modal';
import checkBlueIcon from '../../../../../../assets/image/subscription/check-blue-icon.svg';
import recycleIcon from '../../../../../../assets/image/subscription/recycle-icon.svg';
import exportBlueIcon from '../../../../../../assets/image/subscription/export-blue-icon.svg';
import alertIcon from '../../../../../../assets/image/low-stock-icon.svg';
import Button from '../../../../../../component/ui/Button';

export default function CancelSubscriptionModel({
	isOpenModal,
	setIsOpenModal,
	setIsOpenReasonModal,
}) {
	return (
		<Modal
			className="subscription-modal"
			title={`Cancel Subscription?`}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div>
				<div
					className="fs-5 fw-light rounded-3 px-5 py-4 text-dark"
					style={{ backgroundColor: 'rgba(230, 245, 255, 1)' }}
				>
					{
						'Your subscription will be cancelled at the end of your current billing period. You will not be charged after that. '
					}
				</div>
				<div className="d-flex align-items-start gap-3 my-4">
					<img
						width={20}
						height={20}
						src={checkBlueIcon}
						alt="icon"
					/>
					<span className="fs-5 fw-light text-dark">
						{'You will continue to have access to Pharmnex features until your plan expires.'}
					</span>
				</div>
				<div className="fs-4 fw-bold text-dark my-2">
					{'After your plan expires, you will get 30 days recovery period to:'}
				</div>
				<div className="d-flex align-items-start gap-3 my-4">
					<img
						width={20}
						height={20}
						src={exportBlueIcon}
						alt="icon"
					/>
					<span className="fs-5 fw-light text-dark">{'Export your data'}</span>
				</div>
				<div className="d-flex align-items-start gap-3 my-4">
					<img
						width={20}
						height={20}
						src={recycleIcon}
						alt="icon"
					/>
					<span className="fs-5 fw-light text-dark">
						{'Renew your subscription without losing your data'}
					</span>
				</div>
				<div
					className="fs-5 fw-light rounded-3 px-3 py-2 text-dark"
					style={{ backgroundColor: 'rgba(255, 247, 228, 1)' }}
				>
					<div className="d-flex align-items-center gap-3 my-4">
						<img
							width={20}
							height={20}
							src={alertIcon}
							alt="icon"
						/>
						<span className="fs-5 fw-light text-dark">
							{
								'After this period, your data may be permanently deleted. You can reactivate your subscription anytime before expiry or during recovery period. '
							}
						</span>
					</div>
				</div>
				<div className="d-flex justify-content-end align-items-center gap-4 my-4">
					<Button
						type="button"
						className="mt-0 bg-transparent text-primary border-primary rounded-4 fs-5 fw-light add-pro py-3 px-5 "
						button="Keep Subscription"
						onClick={() => setIsOpenModal(false)}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger rounded-4 text-white fs-5 fw-light add-pro py-3 px-5 "
						button="Cancel Subscription"
						onClick={() => {
							setIsOpenReasonModal(true);
							setIsOpenModal(false);
						}}
					/>
				</div>
			</div>
		</Modal>
	);
}
